import { render, staticRenderFns } from "./ClientCard.vue?vue&type=template&id=7d5ba32a&scoped=true&"
import script from "./ClientCard.vue?vue&type=script&lang=js&"
export * from "./ClientCard.vue?vue&type=script&lang=js&"
import style0 from "./ClientCard.vue?vue&type=style&index=0&id=7d5ba32a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5ba32a",
  null
  
)

export default component.exports